import { render, staticRenderFns } from "./FirewallRules.vue?vue&type=template&id=37894045&scoped=true&"
import script from "./FirewallRules.vue?vue&type=script&lang=js&"
export * from "./FirewallRules.vue?vue&type=script&lang=js&"
import style0 from "./FirewallRules.vue?vue&type=style&index=0&id=37894045&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37894045",
  null
  
)

export default component.exports